import { render, staticRenderFns } from "./PictureDetailsModal.vue?vue&type=template&id=365735b1"
import script from "./PictureDetailsModal.vue?vue&type=script&lang=js"
export * from "./PictureDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports